<template>
  <div>
    <div>
      <!-- Header Area -->
      <header class="main_header_area mha_2"></header>
      <!-- Header Area -->
      <vue-headful
        title="Credimóvil | Contrato Credito"
        :head="{
          'meta[charset]': { charset: 'utf-8' }
        }"
      />
      <menu-solicitud v-bind:use-apply-now="false"></menu-solicitud>
    </div>

    <section class="banner_area banner_area_8"></section>
    <!-- Banner Area -->
    <div class="container">
      <div
        id="page1-div"
        ref="document"
        class="container interline border page-container"
      >
        <div class="col-12 p-3 ">
          <div class="col-12 border border-dark row m-0 p-0">
            <div class="col-1 pt-2 m-0 p-0 border border-dark text-center">
              <img src="../Logo-GPI.png" class="rounded" width="61px" />
            </div>
            <div class="col-4 border border-dark m-0 p-0">
              <div
                class="col border-bottom border-dark bg-secondary text-center"
              >
                <span class="ft11 text-white"> Nombre del Registro</span>
              </div>
              <div class="col  text-center pt-3">
                <span class="ft11">
                  GPI AUTO COMERCIAL SAPI DE C.V.
                  <br />
                  SOLICITUD DE PETICIÓN DE FONDEO
                </span>
              </div>
            </div>
            <div class="col-4 m-0 p-0">
              <div
                class="col border-bottom border-dark bg-secondary text-center"
              >
                <span class="ft11 text-white">Código</span>
              </div>
              <div class="col text-center pt-1">
                <span class="ft11">
                  RE-FOR-08
                </span>
              </div>
              <div
                class="col border-bottom border-top border-dark bg-secondary text-center"
              >
                <span class="ft11 text-white">Departamento</span>
              </div>
              <div class="col text-center pt-1">
                <span class="ft11">
                  FORMALIZACIÓN
                </span>
              </div>
            </div>
            <div class="col-3 border-left border-dark m-0 p-0">
              <div
                class="col border-bottom border-dark bg-secondary text-center"
              >
                <span class="ft11 text-white">Código</span>
              </div>
              <div class="col text-center pt-1">
                <span class="ft11">
                  0
                </span>
              </div>
              <div
                class="col border-bottom border-top border-dark bg-secondary text-center"
              >
                <span class="ft11 text-white">Departamento</span>
              </div>
              <div class="col text-center pt-1">
                <span class="ft11">
                  2023
                </span>
              </div>
            </div>
          </div>
          <div class="col-12 row p-4 m-0">
            <div class="col-9 row m-0 p-0">
              <div class="col-12  border border-danger bg-gpi-azul text-center m-0 p-0 ">
                <span class="ft12 text-white "> Nombre del Registro</span>
              </div>
              <div class="col-12 text-center m-0 p-0 ">
                <span class="ft12 text-white "> Nombre del Registro</span>
              </div>
              <div class="col-12 text-center m-0 p-0 ">
                <span class="ft12 text-white "> Nombre del Registro</span>
              </div>
              <div class="col-12 text-center m-0 p-0 ">
                <span class="ft12 text-white "> Nombre del Registro</span>
              </div>
            </div>
            <div class="col-3 row m-0 p-0">
                <div class="col  border border-dack text-center m-0 p-0 ">
                <span class="ft12 text-white "> Nombre del Registro</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "SolicitudFondeo",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  components: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/fondeo/SolicitudFondeo.vue